/**
 * 通过 value 在树形数据中查找节点。
 *
 * - items 可以是任意含 `value: string` 的对象，children 可选；
 * - 命中后原样返回该节点（保留调用方传入的所有字段）；
 * - 未命中返回 null。
 */
export function findNodeByValue(value, items) {
  for (const item of items) {
    if (item.value === value) return item;
    if (item.children?.length) {
      const found = findNodeByValue(value, item.children);
      if (found) return found;
    }
  }
  return null;
}